import {
  CaseEntityAppEntityCaseEntityItemRead,
  CaseEntityAppEntityCaseEntityRead, ShipmentAppEntityShipmentItemRead
} from '../../openapi';
import { createReducer, on } from '@ngrx/store';
import {
  loadCaseItem, loadCaseItemFailure, loadCaseItemSuccess,
  loadMyCaseList,
  loadMyCaseListFailure,
  loadMyCaseListSuccess, loadShipmentItem, loadShipmentItemFailure, loadShipmentItemSuccess
} from '../actions/my-cases.actions';

export interface MyCasesState {
  loading: number;
  pending: number;
  cases: CaseEntityAppEntityCaseEntityRead[];
  caseItem: CaseEntityAppEntityCaseEntityItemRead | null;
  shipment: ShipmentAppEntityShipmentItemRead | null;
}

export const initialMyCasesState: MyCasesState = {
  loading: 0,
  pending: 0,
  cases: [],
  caseItem: null,
  shipment: null
};

export const myCasesReducer = createReducer(
  initialMyCasesState,
  on(loadMyCaseList, (state) => ({ ...state, loading: state.loading + 1 })),
  on(loadMyCaseListSuccess, (state, action) => ({ ...state, loading: state.loading - 1, cases: action.cases })),
  on(loadMyCaseListFailure, state => ({ ...state, loading: state.loading - 1 })),

  on(loadCaseItem, state => ({ ...state, loading: state.loading + 1 })),
  on(loadCaseItemSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    caseItem: action.caseItem
  })),
  on(loadCaseItemFailure, state => ({ ...state, loading: state.loading - 1 })),

  on(loadShipmentItem, state => ({ ...state, loading: state.loading + 1 })),
  on(loadShipmentItemSuccess, (state, action) => ({ ...state, loading: state.loading - 1, shipment: action.shipment })),
  on(loadShipmentItemFailure, state => ({ ...state, loading: state.loading - 1 }))
);
